import { lightGrey } from "constants/colors";
import styled from "styled-components/macro";

/** source: bifrost-portal */
const getContentHeight = ({
  isLandscape = false,
}: {
  isLandscape?: boolean;
}) => {
  const heightLandscape = 7;
  const heightPortrait = 9.5;
  // const heightLandscape = isWindows ? 7.1 : 7;
  // const heightPortrait = isWindows ? 9.6 : 9.5;
  return isLandscape ? heightLandscape : heightPortrait;
};

/** source: bifrost-portal */
type PrintableStylesType = {
  isLandscape?: boolean;
};

/** source: bifrost-portal */
export const PrintableStyles = styled.div<PrintableStylesType>`
  z-index: 1;
  position: relative;
  .printerOnly {
    display: none;
  }

  @media print {
    height: ${props =>
      getContentHeight({ isLandscape: props.isLandscape })}in !important;
    margin: 0 !important;

    .doNotPrint {
      display: none;
    }

    .printerOnly {
      display: initial !important;
    }

    @page {
      size: ${props => (props.isLandscape ? "landscape" : "portrait")};
    }

    .btnFilters {
      padding: 0 !important;
    }
    .filtersWrapper {
      margin-left: 0;
    }
    .trendsFilterChip {
      position: relative !important;
    }
    .filterTypeLabel {
      position: absolute !important;
      top: -15px !important;
    }
    [class*="TrendsPageStyles"] {
      margin-top: -14px;
    }
    [class*="PnlBreakdownTotalTimeIndicator"] {
      &,
      .hoursMinutes {
        position: absolute !important;
      }
    }
    [class*="TrendsPageTopBar"] {
      .leftSide {
        flex-grow: 0;
      }
      .rightSide {
        flex-grow: 1;
        justify-content: right;
        margin-right: 48px;
      }
    }

    .Card_RangeSelector {
      margin-top: -6px;
      height: fit-content;
      .cardTopbar {
        display: none;
      }
    }
    .dataRowsWrapper {
      position: relative !important;
    }
    .dataRowsWrapper .tagTitle {
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }
    [class*="PnlBarStyles"] {
      position: relative !important;
    }
    .rectArrowRight {
      position: absolute !important;
    }

    .Card_TrendChart,
    .Card_TrendChart_TrendsPage,
    .Card_TodaysProduction {
      .cardContent {
        height: 800px;
      }
      .trendChartStyles {
        height: fit-content;
        margin: auto;
        .btnTrendChartBar {
          height: 400px;
        }
        [class*="BarTitleStyles"] {
          height: 42px;
        }
        [class*="TrendChartCenterMetricStyles"] {
          min-height: 42px;
        }
        padding-top: 2em;
        width: 100%;
        /* for 13-24 bars, shrink horizontally to fit */
        &.manyBars {
          .btnTrendChartBar {
            height: 300px;
          }
          &.flexWrapBars {
            /* if bars wrap over to next line, shrink their height to fit in the page */
            .btnTrendChartBar {
              height: 300px;
            }
          }
          width: ${100 / 0.46}%;
          padding: 0 0.5in;
          flex-wrap: wrap;
          transform-origin: left;
          transform: scaleX(0.46);
          .outlinedWrapper {
            transform: scaleX(1.2) scaleY(0.7);
          }
          .metricPercent {
            transform: scaleX(2.1);
          }
          [class*="TrendChartBarCount"] {
            transform: scaleX(${1 / 0.46});
          }
        }
      }
    }
    .Card_GroupTimeline,
    .Card_Timeline {
      #timelineStyles {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .TimeAxisStyles {
        justify-content: center;
      }
    }
    .Card_GroupTimeline {
      .TimeAxisStyles.splitTimeline {
        gap: 0.5em;
      }
    }
    .Card_Timeline {
      width: 1000px !important;
      margin-left: auto !important;
      margin-right: auto !important;
      #timelineStyles {
        margin-left: auto !important;
        margin-right: auto !important;
        width: 900px !important;
      }
    }
    [class*="SingleGroupMetric__HelpButtonStyles"] {
      display: none;
    }
    .trendsPageStyles {
      .machinesColumn {
        margin-top: 18px;
      }
      #timelineStyles {
        width: 100% !important;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: normal;
        margin-left: -39px !important;
      }
      .timeAxisColumn {
        overflow: hidden;
      }
      .TimeAxisStyles {
        width: 75vw !important;
        justify-content: center;
      }
    }

    .production-segment-loading {
      display: none;
    }
    /* pnl chart */
    /* expand pnlColumn-title to fit long tag names; shrink percentWidth (bar chart) column to make room */
    .pnlColumn-title {
      width: 320px !important;
      max-width: 320px !important;
      min-width: 320px !important;
    }
    .pnlColumn-percent,
    .pnlColumn-numberOfEvents {
      width: 64px !important;
      max-width: 64px !important;
      min-width: 64px !important;
    }
    .pnlColumn-percentWidth,
    .pnlColumn-time,
    .pnlColumn-averageDurationMs,
    .pnlColumn-outputLoss {
      width: 148px !important;
      max-width: 148px !important;
      min-width: 148px !important;
    }
    .PnlChart.with-extra-columns {
      .pnlColumn-title {
        min-width: 240px !important;
        max-width: unset !important;
        flex-grow: 1;
      }
      .pnlColumn-time {
        width: 96px !important;
        max-width: 96px !important;
        min-width: 96px !important;
      }
      .pnlColumn-averageDurationMs {
        width: 80px !important;
        max-width: 80px !important;
        min-width: 80px !important;
      }
      .pnlColumn-percent,
      .pnlColumn-numberOfEvents,
      .pnlColumn-percentWidth,
      .pnlColumn-outputLoss {
        width: 64px !important;
        max-width: 64px !important;
        min-width: 64px !important;
      }
    }
    [data-component-name="PnL Chart"] {
      .page {
        width: fit-content !important;
      }
      /* min-width: 750px !important;
      max-width: 750px !important; */
    }
    .Card_PnlChart {
      &.Card_PnlChart_TimelinePage {
        margin-top: 96px;
        margin-left: auto;
        margin-right: auto;
        width: fit-content;
        .cardContent {
          padding-left: 32px;
          padding-right: 32px;
        }
      }
      .cardContent {
        padding-top: 1em;
        /* min-width: 750px !important;
        max-width: 750px !important; */
        margin: auto;
      }
      .PnlChart {
        padding-top: 0;
        justify-content: center;
      }
    }
    .Card_PnlChart_HubletPage {
      margin-top: 3em !important;
      transform: translateY(3em) !important;
      margin-left: auto;
      margin-right: auto;
      width: fit-content !important;
      max-width: unset !important;
      .cardContent {
        padding: 2em;
        box-sizing: border-box;
      }
      [data-component-name="PnL Chart"] {
        max-width: unset !important;
        width: calc(100% - 4em);
        box-sizing: border-box;
      }
    }
    [class*="HubletViewStyles"] {
      display: none;
    }
    [data-component-name="Navbar"] header {
      visibility: hidden !important;
    }
    [data-component-name="Machine Switcher Dropdown"] {
      position: absolute !important;
      top: -62px;
      left: 0;
      right: 0;
    }
    .departmentName {
      visibility: visible;
      color: black;
      margin: auto;
      width: calc(100vw - 32px);
      justify-content: space-around;
      padding-top: 128px;
      padding-bottom: 48px;
      width: 0px;
      display: flex;
      justify-content: center;
      &.hubletPage {
        position: absolute !important;
        left: 0;
        top: -36px;
        right: 0;
      }
    }
    [class*="GroupMetricsFloater"] {
      position: absolute !important;
    }
    [class*="TopBarStyles"] {
      position: absolute !important;
    }
    .datepickerAndCharts {
      margin-top: 64px;
    }
    .datepickerAndCharts .Card_RangeSelector {
      border: none;
      padding: 1em 0 0;
      margin-top: 42px;
      margin-bottom: -32px;
    }
    [data-testid="ExpandMoreIcon"] {
      visibility: hidden;
    }
    .TimelinesStyles.detailsPage {
      margin: auto;
      margin-bottom: 2em;
    }
    .TimeAxisStyles.detailsPage {
      width: 100%;
      .timeline-overflow-wrapper {
        width: 100%;
      }
      .timeAxisSvg {
        width: 100%;
      }
    }
    [class*="BtnExpandCollapseTimelineStyles"] {
      display: none;
    }
    [class*="HighlightTagsSelectorStyles"] {
      display: none;
    }
    .Card_TodaysProduction {
      width: 90vw;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2em;
      margin-top: 2em;
    }
    .MuiCollapse-root {
      transition: none !important;
    }
    .barRow {
      min-height: 22px !important;
      max-height: 22px !important;
    }
    .HubletView-resizable-container {
      display: none;
    }
    [class*="AnimatedPreferredMetricFloater"] {
      display: none;
    }
    padding-left: 48px;
    padding-right: 48px;
    [data-component-name="Group Switcher Dropdown"] {
      width: calc(100vw - 130px);
    }
    [class*="SimpleDateRange"] {
      position: absolute !important;
      top: 100px;
      left: 0;
      right: 0;
      height: 32px;
    }
    [class*="TrendsPageTopBar__TrendsPageTopBarStyles"]
      [class*="SimpleDateRange"] {
      position: static !important;
    }

    .departmentName + .MuiButton-endIcon {
      display: none;
    }
    .Card_TrendChart_TimelinePage .cardContent {
      height: 600px;
      max-height: 600px;
    }
    [data-component-name="Group Switcher Dropdown"] {
      margin-left: 0;
      justify-content: center;
    }
    .metricDiv.preferred {
      background: ${lightGrey};
      border-radius: 5px;
    }
    .Card_GroupTimeline {
      margin-top: 96px;
      width: 100%;
      box-sizing: border-box;
      .timeAxisColumn {
        width: fit-content;
      }
    }
    .Card_RangeSelector_TimelinePage {
      margin-top: 36px !important;
      border: none;
    }
    .TimeAxisStyles.splitTimeline {
      margin-top: -32px;
      width: 100%;
      box-sizing: border-box;
    }
    .TimeAxisStyles.splitTimeline + .TimeAxisStyles {
      margin-top: 64px !important;
      margin-bottom: 32px;
      width: 100%;
      box-sizing: border-box;
    }
    .TimelinesStyles,
    .timeAxisColumn {
      opacity: 1 !important;
    }
    [class*="TrendsPage__TrendsPageContentStyles"] {
      position: relative !important;
      padding-top: 64px;
    }
    [data-component-name="Trends Page Top Bar"] {
      left: 0;
      right: 0;
      .toolbar {
        box-shadow: none;
        background: none;
      }
      .trendsPageTopBarDivider {
        display: none;
      }
      .rightSide {
        margin-bottom: 112px;
        position: absolute !important;
        left: 0;
        right: 0;
        justify-content: center;
      }
      [class*="ViewingNumProcessesIndicator__ViewingNumProcessesStyles"] {
        position: absolute !important;
        right: 16px;
        top: 33px;
      }
    }
    [data-testid="ArrowDropDownIcon"] {
      display: none;
    }
    .btnFilters {
      display: none;
    }
    .filtersWrapper {
      padding-left: 0;
      margin-left: -64px;
    }
    .Card_TrendChart_TrendsPage {
      height: 50vh;
    }
    .Card_PnlChart_TrendsPage {
      margin-top: 64px;
      box-sizing: border-box;
      margin-left: auto;
      margin-right: auto;
      padding-left: 32px;
      padding-right: 32px;
      margin-bottom: 32px;
      width: fit-content;
      [class*="DashboardPageSectionsCollapsible__CollapseTitleStyles"] {
        display: none;
      }
      .pnlColumn-title {
        width: 320px !important;
        max-width: 320px !important;
        min-width: 320px !important;
      }
      .pnlColumn-percentWidth,
      .pnlColumn-time,
      .pnlColumn-averageDurationMs,
      .pnlColumn-outputLoss {
        width: 120px !important;
        max-width: 120px !important;
        min-width: 120px !important;
      }
      &.manyTrendBars {
        transform: scale(1.2);
        transform-origin: top center;
        margin-bottom: 200px;
      }
    }
    .Card_Timeline_TrendsPage {
      width: 760px !important;
      min-width: 760px !important;
      max-width: 760px !important;
      &.manyTrendBars {
        width: 1000px !important;
        min-width: 1000px !important;
        max-width: 1000px !important;
      }
      .TimeAxisStyles {
        padding: 0;
        margin-left: 32px;
        background: none;
      }
    }
  }
`;
